"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearRingContainsExtent = linearRingContainsExtent;
exports.linearRingContainsXY = linearRingContainsXY;
exports.linearRingsContainsXY = linearRingsContainsXY;
exports.linearRingssContainsXY = linearRingssContainsXY;

var _extent = require("../../extent.js");

/**
 * @module ol/geom/flat/contains
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} Contains extent.
 */
function linearRingContainsExtent(flatCoordinates, offset, end, stride, extent) {
  var outside = (0, _extent.forEachCorner)(extent,
  /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains (x, y).
   */
  function (coordinate) {
    return !linearRingContainsXY(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
  });
  return !outside;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */


function linearRingContainsXY(flatCoordinates, offset, end, stride, x, y) {
  // https://geomalgorithms.com/a03-_inclusion.html
  // Copyright 2000 softSurfer, 2012 Dan Sunday
  // This code may be freely used and modified for any purpose
  // providing that this copyright notice is included with it.
  // SoftSurfer makes no warranty for this code, and cannot be held
  // liable for any real or imagined damage resulting from its use.
  // Users of this code must verify correctness for their application.
  var wn = 0;
  var x1 = flatCoordinates[end - stride];
  var y1 = flatCoordinates[end - stride + 1];

  for (; offset < end; offset += stride) {
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];

    if (y1 <= y) {
      if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) {
        wn++;
      }
    } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) {
      wn--;
    }

    x1 = x2;
    y1 = y2;
  }

  return wn !== 0;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */


function linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y) {
  if (ends.length === 0) {
    return false;
  }

  if (!linearRingContainsXY(flatCoordinates, offset, ends[0], stride, x, y)) {
    return false;
  }

  for (var i = 1, ii = ends.length; i < ii; ++i) {
    if (linearRingContainsXY(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) {
      return false;
    }
  }

  return true;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */


function linearRingssContainsXY(flatCoordinates, offset, endss, stride, x, y) {
  if (endss.length === 0) {
    return false;
  }

  for (var i = 0, ii = endss.length; i < ii; ++i) {
    var ends = endss[i];

    if (linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y)) {
      return true;
    }

    offset = ends[ends.length - 1];
  }

  return false;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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